import { OutlinedInput } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import { useCallback, useRef, useState } from "react";
import { ChromePicker } from "react-color";
import { IProductParams } from "../../../model";
import { appLogger } from "../../../utils";
import useClickOutside from "./useClickOutside";

const BrandingBackgrountColor = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "BrandingBackgrountColor",
      component: "add-product",
      fileName: "BrandingBackgrountColor.tsx",
      prpos: props,
    },
  });
  const { productParams, setProductParams, field, bgColor } = props;
  const [ismainTitleClrPalletOpen, setmainTitleClrPalletOpen] = useState(false);

  const mainTitileClrPopover = useRef<any>(null);
  const mainTitleclrpalleteclose = useCallback(
    () => setmainTitleClrPalletOpen(false),
    []
  );

  useClickOutside(mainTitileClrPopover, mainTitleclrpalleteclose);

  const handleColorChange = (event: any) => {
    const color = event;
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.branding) {
          temp.products[0].feedbackAgentSettings.branding = {};
        }
        if (field == "Main Background") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-agent-bg"
          ] = color;
          setProductParams(temp);
        } else if (field == "Card Background") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-bg"
          ] = color;
          setProductParams(temp);
        } else if (field == "Primary Button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-primary-button-bg"
          ] = color;
          setProductParams(temp);
        } else if (field == "Secondary Button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-secondary-button-bg"
          ] = color;
          setProductParams(temp);
        } else if (field == "InputField Text") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-input-field-text-color"
          ] = color;
          setProductParams(temp);
        } else if (field == "InputField Background") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-input-field-bg-color"
          ] = color;
          setProductParams(temp);
        } else if (field == "InputField Border") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-input-border-color"
          ] = color;
          setProductParams(temp);
        } else if (field == "Card Svg Foreground") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-card-svg-fg-color"
          ] = color;
          setProductParams(temp);
        } else if (field == "Card Svg Background") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-card-svg-bg-color"
          ] = color;
          setProductParams(temp);
        } else if (field == "Card Border") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-card-border-color"
          ] = color;
          setProductParams(temp);
        } else if (field == "Selected Star") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-selected-star-color"
          ] = color;
          setProductParams(temp);
        } else if (field == "Unselected Star") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-unselected-star-color"
          ] = color;
          setProductParams(temp);
        } else if (field == "Primary Button Border") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-primary-button-border-color"
          ] = color;
          setProductParams(temp);
        } else if (field == "Secondary Button Border") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-secondary-button-border-color"
          ] = color;
          setProductParams(temp);
        }
      }
    }
  };

  return (
    <>
      {/* ******************Form Appreance******************************** */}

      <Grid>
        <div className="mainAgentpickerColorDiv">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
              <Grid xs={2}>
                <div
                  className="swatch"
                  style={{ backgroundColor: bgColor }}
                  onClick={() => setmainTitleClrPalletOpen(true)}
                />
              </Grid>
              <Grid xs={10}>
                <div>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel>
                      {(field.split(" ")[0] == "Main" || field.split(" ")[0] == "Card" || field.split(" ")[0] == "Selected" || field.split(" ")[0] == "Unselected") ? field : field.substr(field.indexOf(" ") + 1)} Color{" "}
                    </InputLabel>
                    <OutlinedInput
                      id={`${field}`}
                      type="text"
                      value={bgColor}
                      label="Background Color"
                      onChange={(event) => {
                        handleColorChange(event.target.value);
                      }}
                      onFocus={(event) => {
                        setmainTitleClrPalletOpen(true);
                      }}
                    />
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </Box>
          {ismainTitleClrPalletOpen && (
            <div className="popoverpick" ref={mainTitileClrPopover}>
              {/* <CloseIcon
                    className="cursor-pointer picker-close"
                    onClick={() => mainTitleclrpalleteclose()}
                  /> */}
              <div
                className="cursor-pointer picker-close"
                onClick={() => mainTitleclrpalleteclose()}
              >
                Close
              </div>
              <ChromePicker
                color={bgColor}
                onChange={(color) => {
                  handleColorChange(color.hex);
                }}
              />
            </div>
          )}
        </div>
      </Grid>
      {/* *****************Form Appreance************************************** */}
    </>
  );
};

export default BrandingBackgrountColor;
